import { render, staticRenderFns } from "./PersonEdit.view.vue?vue&type=template&id=e94d1f7c"
import script from "./PersonEdit.view.vue?vue&type=script&lang=js"
export * from "./PersonEdit.view.vue?vue&type=script&lang=js"
import style0 from "./PersonEdit.view.vue?vue&type=style&index=0&id=e94d1f7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports